import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface CollapsibleCardProps {
  title: string;
  icon?: React.ReactNode;
  defaultOpen?: boolean;
  headerExtra?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function CollapsibleCard({
  title,
  icon,
  defaultOpen = false,
  headerExtra,
  children,
  className = '',
}: CollapsibleCardProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden ${className}`}>
      <div
        role="button"
        tabIndex={0}
        onClick={() => setOpen((v) => !v)}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen((v) => !v); } }}
        className="w-full flex items-center justify-between px-6 py-5 border-b border-gray-200 bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer select-none"
      >
        <div className="flex items-center gap-3">
          {icon && <span className="flex-shrink-0">{icon}</span>}
          <span className="text-xl font-bold text-gray-900">{title}</span>
        </div>
        <div className="flex items-center gap-2">
          {headerExtra && (
            <div onClick={(e) => e.stopPropagation()}>
              {headerExtra}
            </div>
          )}
          <ChevronDown
            className={`w-5 h-5 text-gray-500 transition-transform duration-200 flex-shrink-0 ${open ? 'rotate-180' : ''}`}
          />
        </div>
      </div>
      <div
        className="grid transition-[grid-template-rows] duration-200 ease-in-out"
        style={{ gridTemplateRows: open ? '1fr' : '0fr' }}
      >
        <div className="overflow-hidden">
          {children}
        </div>
      </div>
    </div>
  );
}
